import React from 'react';
import * as S from './UsersList.styled';
import { useSelector } from 'react-redux';
import Table from './components/Table';
import { QuerySelector, UsersListItemsSelector } from './UsersListSlice';
import { IUser } from 'interfaces/main';

const UsersList: React.FC = () => {

  // Список загруженных сервисных. центров
  const users = useSelector(UsersListItemsSelector);
  const query = useSelector(QuerySelector);


  const items = users.filter((item: IUser) => {
    const check =
      item.name.toLocaleLowerCase().includes(query) ||
      item.phone.toLocaleLowerCase().includes(query) ||
      item.email.toLocaleLowerCase().includes(query);

    return !query ? true : check;
  });

  return (
    <S.Wrap>
      <Table items={items}/>
    </S.Wrap>
  );
};

export default UsersList;
